/* redirect proxy
 *
 * Wrapper of jQuery's ajax call behavior for redirecting page if needed
 * Redirects page to a specific URL if user is logged out on server (e.g. due to a time-out) and user action fires an ajax call
 * In case of redirect, server responds with json {"redirectUrl", "http://www.domein.nl/pagina.html"}
 *
 * */
if (typeof jQuery != "undefined") {
    (function() {
        "use strict";
        var proxiedAjax = jQuery.ajax;
        jQuery.ajax = function() {
            if (arguments.length > 0) {
                var args = arguments[arguments.length - 1];
                if (args && args.redirLogout) {
                    var proxiedSuccess = args.success;
                    var proxiedDone = args.done;

                    if (
                        typeof proxiedSuccess !== "undefined" &&
                        proxiedSuccess.apply
                    ) {
                        args.success = function(data) {
                            if (data.redirectUrl) {
                                window.location = data.redirectUrl;
                            } else {
                                proxiedSuccess.apply(this, arguments);
                            }
                        };
                    } else if (
                        typeof proxiedDone !== "undefined" &&
                        proxiedDone.apply
                    ) {
                        args.done = function(data) {
                            if (data.redirectUrl) {
                                window.location = data.redirectUrl;
                            } else {
                                proxiedDone.apply(this, arguments);
                            }
                        };
                    }
                }
            }
            return proxiedAjax.apply(this, arguments);
        };
    })();
}

/* test --
 var testUrl = 'http://localhost/json/redirect-url.json';

 // Normal jQuery ajax behaviour
 $.ajax(testUrl, {
 success: function() {
 console.log('normal behaviour');
 }
 });

 // Special jQuery ajax behaviour
 $.ajax(testUrl, {
 'redirLogout': true,
 success: function() {
 console.log('redirect!');
 }
 });
 -- */
